<template>
  <div>
    <modal
      size="small"
      :hideCloseButton="true"
      v-if="visible"
      @close-modal="closeModal"
      :submit="false"
      :show-controls="true"
    >
      <div slot="header">
        Tem certeza de que deseja recriar o token?
      </div>
      <div slot="content">
        <p> Essa ação irá recriar o seu token atual. Certifique-se de atualizar o token em todos os locais relevantes após a recriação.</p>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="btn normal-background"
          @click.prevent="closeModal">
          Cancelar
        </button>
        <button
          type="button"
          :disabled="submited"
          class="btn btn-md"
          @click="onSubmit"
          style="background-color: #e8384f"
        >
          Gerar novo token
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "ModalConfirmarNovoTokenCallback",
  props:{
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      submited: false,
    };
  },
  methods: {
    onSubmit: function() {
      this.submited = true;
      EventBus.$emit('loading-show');

      axios({
        method: "post",
        url: "/gerar-token-callback"
      })
        .then(response => {
          EventBus.$emit('loading-hide');
          window.location.reload();
        })
        .catch(error => {
          this.submited = false;

          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    closeModal: function() {
      this.$emit("closeModal");
    }
  }
}
</script>

<style scoped lang="stylus">
.btn-success
  background-color #00a65a
  border-color #008d4c
</style>
